export default {
    primary: '#ee042e',
    black: '#000000',
    white: '#ffffff',
    whiteGrey: '#f8f8f8',
    lightGrey: '#eeeeee',
    darkGrey: '#696969',
};
